import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ItemTable from '../item-table'
import Pagination from "../pagination";
import Navbar from '../navbar';
import LazyLoading from '../../../../../components/lazy-loading';
import ItemTableCode from '../item-table-code';
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { MagnifyingGlassIcon, PlusIcon } from '@heroicons/react/24/outline';
import ModalCadCodes from '../../modal-cad-codes';
import { toast } from 'react-toastify';
import { translations } from '../../../../../utils/language';
import PaginationCodes from '../pagination-codes';
import { BarFilters, BarFiltersLeft, Search } from './styled';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function TableSerial(props) {

    // const [page, setpage] = useState(1)
    // const [perPage, setperPage] = useState(40)
    // const [search, setSearch] = useState("")
    // const { id } = useParams();
    // const dispatch = useDispatch()

    // const serials = useSelector((state) => state.reducerSerials);

    // useEffect(() => {
    //     
    // }, [serials])



    useEffect(() => {
        //dispatch({ type: "SAGA_LIST_CODES", payload: { id: id, perPage: perPage, page: page, search: search } });
    }, [])


    const checkbox = useRef()
    const [checked, setChecked] = useState(false)
    const [indeterminate, setIndeterminate] = useState(false)
    const [selectedCodes, setSelectedCodes] = useState([])
    const dispatch = useDispatch()
    const [page, setpage] = useState(1)
    const [perPage, setperPage] = useState(40)
    const [search, setSearch] = useState("")

    const [dataCodes, setDataCodes] = useState([])
    const serials = useSelector((state) => state.reducerSerials);
    const [visibleModalCadCodes, setVisibleModalCadCodes] = useState(false)
    const { id } = useParams();

    useEffect(() => {
    
    }, [serials])

    const handleClick = () => {
        if (checkbox.current) {
            checkbox.current.click();
        }
    };

    useEffect(() => {
        
        serials?.data?.data?.length > 0 && setDataCodes(serials.data.data)
        serials?.data?.data == undefined && setDataCodes([])
    }, [serials])

    useLayoutEffect(() => {
        const isIndeterminate = selectedCodes.length > 0 && selectedCodes.length < dataCodes.length
        setChecked(dataCodes.length == 0 || serials.loading ? false : selectedCodes.length === dataCodes.length)
        setIndeterminate(isIndeterminate)
        //checkbox.current.indeterminate = isIndeterminate
    }, [selectedCodes])

    function toggleAll() {
        setSelectedCodes(checked || indeterminate ? [] : dataCodes)
        setChecked(!checked && !indeterminate)
        setIndeterminate(false)
    }

    const location = useLocation()

    const removeQueryParam = (param) => {
        // const url = new URL(window.location);
        // url.searchParams.delete(param);
        // window.history.pushState({}, "", url);
    };

    const [used, setUsed] = useState("")
    useEffect(() => {
        console.log("location ::", location)
        if(location.search != ""){
            setUsed(location.search.substring(1).split("=")[1])
            //console.log("user ::", location.search.substring(1).split("=")[1])
        }
    }, [location])

    useEffect(() => {
        console.log("user =>",used)
    }, [used])
    



    const goSearch = () => {
        dispatch({ type: "SAGA_LIST_CODES", payload: { id: id, perPage: perPage, page: page, search: search, used: location.search.substring(1).split("=")[1] } });
    }

    useEffect(() => { goSearch() }, [page,])

    const [visibleModalCadCode, setVisibleModalCadCode] = useState(false)

    const reducerDeleteCodes = useSelector((state) => state.reducerDeleteCodes);
    const language = useSelector((state) => state.reducerLanguage);


    useEffect(() => {
        console.log("testandooooooo", reducerDeleteCodes)
        if (reducerDeleteCodes.loading == false && reducerDeleteCodes.error == false && reducerDeleteCodes?.data?.length == 0) {

        } else {
            const id = "reducerDeleteCodes"
            if (reducerDeleteCodes.loading) {
                toast.loading(translations["Aguarde..."][language.data], { toastId: id })
            } else {
                if (reducerDeleteCodes.error) toast.update(id, { render: "Erro ao tentar excluír.", type: "error", isLoading: false, hideProgressBar: false, autoClose: 3000, closeOnClick: true });
                else {
                    toast.update(id, { render: "Excluído com sucesso", type: "success", isLoading: false, hideProgressBar: false, autoClose: 2000, closeOnClick: true })
                    //props.setVisible(false)
                    goSearch()
                    dispatch({ type: "CODES_DELETE_RESET" })
                }
            }
        }
    }, [reducerDeleteCodes])

    return (
        serials.loading ?
            <LazyLoading /> :
            <>

                <ModalCadCodes goSearch={goSearch} visible={visibleModalCadCode} setVisible={setVisibleModalCadCode} />

                <div className="px-4 sm:px-6 lg:px-8">
                    <Navbar serials={serials?.data?.data?.serials_number} />
                    <div style={{ marginBottom: "28px" }} className="sm:flex sm:items-center">
                        <div className="sm:flex-auto">
                            <h1 className="text-base font-semibold leading-6 text-gray-900">{translations["page-codes-title"][language.data]}</h1>
                            <p className="mt-2 text-sm text-gray-700">
                                {translations["page-codes-description"][language.data]}
                            </p>
                        </div>

                        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                            <button
                                onClick={() => { setVisibleModalCadCode(true) }}
                                type="button"
                                className="inline-flex items-center gap-x-2 rounded-md bg-green-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                                <PlusIcon aria-hidden="true" className="-ml-0.5 h-5 w-5" />
                                {"Cadastrar"}
                            </button>
                        </div>
                    </div>

                    <BarFilters style={{ paddingRight: "20px" }}>
                        <span style={{ display: "flex", justifyContent: "space-between" }}>
                            <BarFiltersLeft style={{ marginRight: "20px" }}>
                                <Search>
                                    <span>
                                        <MagnifyingGlassIcon style={{ width: "20px" }} />
                                    </span>
                                    <input onKeyPress={(e) => { e.key == "Enter" && goSearch() }} type='text' placeholder={"Pesquisar por código"} value={search} onChange={(e) => { setSearch(e.target.value) }} />
                                </Search>
                            </BarFiltersLeft>

                            {/* <FiltersProducts
                                medias={medias} setMedias={setMedias}
                                noMedias={noMedias} setNoMedias={setNoMedias}
                            /> */}
                        </span>
                    </BarFilters>



                    <div className="mt-0 flow-root">
                        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                <div className="relative">
                                    {/* {selectedProducts.length > 0 && (
                                        <div className="absolute left-14 top-0 flex h-12 items-center space-x-3 bg-white sm:left-12">
                                            {JSON.parse(localStorage.getItem("depoimentos@login"))?.integration?.platform == "hotmart" ||
                                                JSON.parse(localStorage.getItem("depoimentos@login"))?.integration?.platform == "landpage" ||
                                                JSON.parse(localStorage.getItem("depoimentos@login"))?.integration?.platform == "custom" ? <></> :
                                                <button
                                                    onClick={() => {
                                                        //sincMulti()
                                                    }}
                                                    type="button"
                                                    className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                                                >
                                                    {"Sincronizar"}
                                                </button>}
                                        </div>
                                    )} */}
                                    <table className="min-w-full table-fixed divide-y divide-gray-300 bg-white">
                                        <thead>
                                            <tr>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    Data
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                                    Código
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                                                    Status
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                                                    Envio
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-gray-900">
                                                    Licença
                                                </th>
                                                <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-3">
                                                    <span className="sr-only">Edit</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {serials?.data?.data?.map((item) => (
                                                <ItemTableCode
                                                    classNames={classNames}
                                                    goSearch={goSearch}
                                                    item={item} />
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <PaginationCodes setPage={setpage} />
            </>
    )

}